import React from "react";
import "./InRouteDash.scss";
import { useTranslation } from "react-i18next";
import questionIcon from "assets/ui-img/questionMarkWhiteCircleBg.png";
import wrenchIcon from "assets/ui-img/wrenchWhiteCircleBG.png";
import { useState } from "react";

//little component which serves as a textual confirmation to what may be occuring on the map as post dispatch progresses.
export default function InRouteDash(props) {
  const { t } = useTranslation();

  return (
    <div className="enRoute" style={{ background: "white" }}>
      <div className="flexItem">
        <div className="time">
          <h2>
            {props.data.time !== "Invalid date"
              ? props.data.time
              : "loading..."}
          </h2>
          <p>{t("description.ProviderEnrouteEstimation")}</p>
        </div>
        <div className="people">
          <h3>{props.data.servProv || "loading..."}</h3>
          <p>{t("description.ProviderEnrouteServProv")}</p>
        </div>
      </div>

      <div className="flexItem">
        <div className="status">
          <h4 style={{ paddingLeft: "15px" }}>
            {t("description.ProviderEnrouteStatus")} |{" "}
            <span style={{ color: "darkgreen" }}>
              {props.data.status || "loading..."}
            </span>
          </h4>
        </div>
        <div className="button" style={{ textAlign: "center" }}>
          <button onClick={props.helpFunc}>
            <img src={questionIcon} alt="logo stuff" />
          </button>
          <h5>{t("description.ProviderEnrouteHelp")}</h5>
        </div>
        <div className="button" style={{ textAlign: "center" }}>
          <button onClick={props.cancelFunc}>
            <img src={wrenchIcon} alt="logo stuff" />
          </button>
          <h5>{t("description.ProviderEnrouteCancel")}</h5>
        </div>
      </div>
    </div>
  );
}
